import ui from './ui.json'

export default {
  language: 'Español',
  languageTag: 'es',
  ...ui
}
